import React, { useContext } from 'react';
import {
  node,
  number,
  bool,
  string,
  object
} from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';

const CheckNearByStore = (props) => {
  const { channel } = useContext(ExperienceContext);
  const {
    itemId,
    quantity,
    lineItemId,
    children,
    isShipToHomeEligible,
    addOnsAssemblyAndMore,
    isCartTiles,
    storeIdFromCart
  } = props;
  let host = 'https://www.homedepot.com';
  if (typeof window !== 'undefined') {
    host = window.location.origin.match(/local/g)
      ? window.location.origin : 'https://www.homedepot.com';
  }

  const { storeId } = useStore();

  const cartReqParams = {
    itemId,
    host,
    quantity,
    keyword: isCartTiles ? storeIdFromCart : storeId,
    channel,
    isShipToHomeEligible,
    alterBrowserHistory: true,
    addOnsAssemblyAndMore
  };

  if (lineItemId) {
    cartReqParams.lineItemId = lineItemId;
  }

  function triggerSelectStore(event) {
    event.stopPropagation();
    event.preventDefault();
    window.LIFE_CYCLE_EVENT_BUS.trigger('cart.select-store', {
      cartReqParams
    });
  }

  return (
    <span
      role="button"
      tabIndex={0}
      className="u__default-link pointer check-nearby-tile-container"
      onClick={triggerSelectStore}
      data-testid="check-nearby-stores-link"
    >
      {children}
    </span>
  );
};

CheckNearByStore.propTypes = {
  itemId: string.isRequired,
  children: node.isRequired,
  isShipToHomeEligible: bool,
  // eslint-disable-next-line react/forbid-prop-types
  addOnsAssemblyAndMore: object,
  isCartTiles: bool,
  storeIdFromCart: string,
  lineItemId: string,
  quantity: number
};

CheckNearByStore.defaultProps = {
  isShipToHomeEligible: false,
  addOnsAssemblyAndMore: null,
  storeIdFromCart: '',
  isCartTiles: false,
  lineItemId: '',
  quantity: 1
};

export { CheckNearByStore };
